import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { textPlaceHolder, titlePlaceholder, } from "../../../helpers/placeholders";
import RenderElement from "../../../helpers/RenderElement";
import { SideEditOptions } from "../../../types/elements";
import Container from "../Common/Container";
import ElementColorImage from "../Common/ElementColorImage";
import Icon from "../Common/Icon";
import Link from "../Common/Link";
import RepeatGroup from "../Common/RepeatGroup";
import RepeatItem from "../Common/RepeatItem";
import Typography from "../Common/Typography";
const repeatConfig = [
    {
        type: SideEditOptions.Select,
        config: {
            key: "items-desktop",
            label: "Aantal items op desktop",
            defaultValue: "lg:grid-cols-3",
            open: false,
            selectOptions: [
                {
                    value: "lg:grid-cols-1",
                    label: "1",
                },
                {
                    value: "lg:grid-cols-2",
                    label: "2",
                },
                {
                    value: "lg:grid-cols-3",
                    label: "3",
                },
                {
                    value: "lg:grid-cols-4",
                    label: "4",
                },
                {
                    value: "lg:grid-cols-5",
                    label: "5",
                },
                {
                    value: "lg:grid-cols-6",
                    label: "6",
                },
            ],
        },
    },
    {
        type: SideEditOptions.Select,
        config: {
            key: "items-tablet",
            label: "Aantal items op tablet",
            defaultValue: "md:grid-cols-2",
            open: false,
            selectOptions: [
                {
                    value: "md:grid-cols-1",
                    label: "1",
                },
                {
                    value: "md:grid-cols-2",
                    label: "2",
                },
                {
                    value: "md:grid-cols-3",
                    label: "3",
                },
                {
                    value: "md:grid-cols-4",
                    label: "4",
                },
            ],
        },
    },
    {
        type: SideEditOptions.Select,
        config: {
            key: "items-mobile",
            label: "Aantal items op mobiel",
            defaultValue: "grid-cols-1",
            open: false,
            selectOptions: [
                {
                    value: "grid-cols-1",
                    label: "1",
                },
                {
                    value: "grid-cols-2",
                    label: "2",
                },
                {
                    value: "grid-cols-3",
                    label: "3",
                },
            ],
        },
    },
];
const ContentFeatureBox = ({ elementId, elementProps, editable }) => {
    const renderElement = RenderElement.setProps(elementProps);
    return (_jsx(ElementColorImage, { editorKey: "container-1", renderElement: renderElement, elementId: elementId, className: "p-8", children: _jsxs(Container, { children: [_jsxs("div", { className: "mx-auto max-w-2xl lg:text-center", children: [_jsx(Typography, { fontType: "heading", component: "h2", "editor-key": "title-1", ...renderElement.renderClassName("title-1", "text-site-500 mt-2 text-3xl font-bold tracking-tight sm:text-4xl"), children: renderElement.renderText("title-1", titlePlaceholder.value) }), _jsx(Typography, { component: "article", "editor-key": "text-1", ...renderElement.renderClassName("text-1", "mt-6 text-lg leading-8 prose text-gray-600"), children: renderElement.renderText("text-1", textPlaceHolder.value) })] }), _jsx(RepeatItem, { className: `mt-4 grid gap-[50px] ${renderElement.renderProp("feature-repeat", "items-mobile")?.value ||
                        "grid-cols-1"} ${renderElement.renderProp("feature-repeat", "items-tablet")?.value ||
                        "md:grid-cols-2"} ${renderElement.renderProp("feature-repeat", "items-desktop")
                        ?.value || "lg:grid-cols-3"}`, repeatId: "feature-repeat", elementProps: elementProps, elementId: elementId, create: true, editable: editable, "editor-key": "feature-repeat", ...renderElement.renderAttributeOptions(repeatConfig, "feature-repeat"), children: _jsx(_Fragment, { children: [
                            "default",
                            ...(elementProps?.["feature-repeat"]?.items || []),
                        ].map((repeatKey) => (_jsx(RepeatGroup, { index: repeatKey, group: "feature-repeat", editable: editable, elementId: elementId, children: _jsxs("div", { className: "text-center", children: [_jsx("div", { children: _jsx("span", { className: "relative", children: _jsx(Icon, { "editor-key": `feature-repeat-${repeatKey}-icon-1`, ...renderElement.renderIcon(`feature-repeat-${repeatKey}-icon-1`), ...renderElement.renderClassName(`feature-repeat-${repeatKey}-icon-1`, `mx-auto h-[60px] w-[60px] md:h-[90px] md:w-[90px] text-gray-900`) }) }) }), _jsxs("div", { className: "mt-[30px]", children: [_jsx(Typography, { fontType: "heading", component: "h3", "editor-key": `feature-repeat-${repeatKey}-title`, ...renderElement.renderClassName(`feature-repeat-${repeatKey}-title`, "text-2xl font-medium text-gray-900"), children: renderElement.renderText(`feature-repeat-${repeatKey}-title`, titlePlaceholder.value) }), _jsx(Typography, { component: "article", "editor-key": `feature-repeat-${repeatKey}-text`, ...renderElement.renderClassName(`feature-repeat-${repeatKey}-text`, "mx-auto mt-5 leading-[30px] prose text-gray-900"), children: renderElement.renderText(`feature-repeat-${repeatKey}-text`, textPlaceHolder.value) }), _jsx(Link, { "editor-key": `feature-repeat-${repeatKey}-link`, ...renderElement.renderClassName(`feature-repeat-${repeatKey}-link`, "text-base text-site-500 hover:text-site-600 mt-4 block"), ...renderElement.renderLink(`feature-repeat-${repeatKey}-link`), children: _jsx(Typography, { component: "span", "editor-focuskey": `feature-repeat-${repeatKey}-link`, children: renderElement.renderLink(`feature-repeat-${repeatKey}-link`)["editor-link-label"] }) })] })] }, repeatKey) }))) }) })] }) }));
};
export default ContentFeatureBox;
//# sourceMappingURL=ContentFeatureBox.js.map